import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import Content from "./components/content.jsx";
import ReportUtils from "../../../utils/report-utils.js";
import {Card} from "../../../components/card/card.jsx";
import axios from "axios";
const API_URL = import.meta.env.VITE_API_URL;

const initialFilter = {
    start: "",
    end: "",
    requester: [],
    material: "",
    permanent: false
}

const filterLabels = {
    dtStart: "D/h entrega inicial",
    dtEnd: "D/h entrega final",
    requester: "Solicitante",
    material: "Material",
    permanent: "Permanente",
};
const MaterialCautions = () => {
    const [loading, setLoading] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [filters, setFilters] = useState(initialFilter);
    const [reportData, setReportData] = useState(null);
    const [dataLength, setDataLength] = useState(0)
    const [canPrint, setCanPrint] = useState(false);
    const [title] = useState("Materiais em cautela");
    const searchWithoutFilter = localStorage.getItem("search_without_filter");
    const [headerSelected, setHeaderSelected] = useState(-1);

    useEffect(() => {
        let filtersParsed;
        const filtersDecode = localStorage.getItem("filter_material_cautions");

        if (searchWithoutFilter && !filtersDecode) {
            setFilters([]);
            apply({}, searchWithoutFilter)
            localStorage.removeItem("search_without_filter");
        } else if (filtersDecode) {
            filtersParsed = JSON.parse(filtersDecode);

            setFilters(filtersParsed);
            apply(filtersParsed, searchWithoutFilter)
        }

        localStorage.removeItem("filter_material_cautions");
    }, []);



    useEffect(() => {
        if (!reportData) return;

        ReportUtils.appendFilters(
            ReportUtils.filters({
                ...filters,
                dtStart: filters.start ? ReportUtils.formatDateTime(filters.start) : "",
                dtEnd: filters.end ? ReportUtils.formatDateTime(filters.end) : "",
                start: null,
                end: null,
            }, filterLabels)
        );

    }, [reportData]);

    const apply = async (filter, searchWithoutFilter) => {
        ReportUtils.applyLoad({
            setLoading,
            clearContent: () => {
                setReportData(null)
            }
        });

        if (!searchWithoutFilter) {
            filter.requester = filter.requester.length > 0 ? filter.requester.map(r => r.value) :  []
        } else {
            filter = { no_filter: true}
        }

        try {
            const { data: response } = await axios.post(API_URL + "/material_cautions/apply", {filter});

            const data = response.data;

            setReportData(data);
            setDataLength(data.length)

            const scale = window.visualViewport?.scale ?? 1;
            if (window.innerWidth <= 1440 || scale > 1) setCollapsed(true);

            setTimeout (() => {
                setCanPrint(true);
            },  600);

        } catch (error) {

            ReportUtils.alertErrorMessage("Erro ao gerar o relatório.");
            console.error("Erro ao gerar o relatório", error);

        } finally {
            setLoading(false);
        }
    };

    const printComponentRef = useRef(null);

    useLayoutEffect(() => {
        if (canPrint) printComponentRef.current?.print()
    }, [canPrint]);

    return (
        <div className={"flex"}>

            <Template isLoading={loading}>
                <Template.Header>
                    <div className="flex justify-between w-full">
                        <Template.Title>{title}</Template.Title>
                        <HeaderButtons
                            exportable={false}
                            exportInSheets={false}
                            printable={true}
                            headerChange={true}
                            printComponentRef={printComponentRef}
                            reportData={reportData}
                            data={dataLength}
                            headerSelected={headerSelected}
                            setHeaderSelected={setHeaderSelected}
                            setCollapsed={setCollapsed}
                        />
                    </div>
                </Template.Header>
            </Template>

            <Card className={`w-full h-fit m-2 ${!reportData || dataLength === 0 ? 'mt-[59px]' : 'mt-[61px]' } print:!mt-[-15px] transform ${!reportData || dataLength === 0 ? '!bg-[#f3f3f4] !border-none !-translate-y-[5px]' : ''} ${collapsed ? 'ml-2' : ''}`}>
                <Card.Body>
                    <div className={`flex-1 ${!reportData || dataLength === 0 ? 'p-[0]' : 'px-[20px] py-[5px]'}`}>
                        <NoDataContent reportData={reportData} data={dataLength}/>
                        <Content reportData={reportData} data={dataLength} filters={filters} entity={headerSelected} title={title} collapsed={collapsed} setLoading={setLoading} printComponentRef={printComponentRef} searchWithoutFilter={searchWithoutFilter}/>
                    </div>
                </Card.Body>
            </Card>

        </div>
    );
};

export default MaterialCautions;